import { render, staticRenderFns } from "./TableWithoutRecords.vue?vue&type=template&id=04192cb7"
import script from "./TableWithoutRecords.vue?vue&type=script&lang=js"
export * from "./TableWithoutRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports